export const NMSCOLUMN_CONFIG = {
  'NMS-Worker-Logs': [
    { field: 'nmsrun_timestamp',
      headerName: 'NMS Run Timestamp',
      width: 200,
      valueGetter: (params) => {
        const timestamp = params; // Ensure `params` has the correct timestamp value
        if (timestamp) {
          // Slice to remove seconds and milliseconds
          return timestamp.slice(0, 16);
        }
        return '-';
      },
     },
    { field: 'brand_name', headerName: 'Brand Name', width: 150 },
    { field: 'list_rules', headerName: 'List of Rules', width: 400 },
    { field: 'flag_alert_created', headerName: 'Alert Created(Y/N)', width: 150 },
    { field: 'alert_id', headerName: 'Alert Id', width: 150 },
    { field: 'estation_name', headerName: 'Estation Id', width: 150 },
  ],
  'NMS-Alert-Zendesk':[
    { field: 'nmsalert_reg_timestamp',
    headerName: 'Timestamp-Alert-Reg-on-NMS',
    width: 250,
    valueGetter: (params) => {
      const timestamp = params; // Ensure `params` has the correct timestamp value
      if (timestamp) {
        // Slice to remove seconds and milliseconds
        return timestamp.slice(0, 16);
      }
      return '-';
    },
   },
    // { field: 'store', headerName: 'Timestamp-Alert-Reg-on-NMS', width: 150 },
    { field: 'brand_name', headerName: 'Brand Name', width: 300 },
    { field: 'estation_name', headerName: 'Estation ID', width: 150 },
    { field: 'alert_id', headerName: 'NMS Alert ID', width: 150 },

    { field: 'nms_job_id', headerName: 'NMS Job ID', width: 200 },
    { field: 'alert_message', headerName: 'Alert Message', width: 150 },
    {
      field: 'ticket_type',
      headerName: 'Ticket Type',
      width: 150,
    },
    { field: 'ticket_priority', headerName: 'Ticket Priority', width: 150 },
    { field: 'nms_oid', headerName: 'NMS OID (Zendesk)', width: 300 },

    { field: 'existing_zendesk_ticket_id', headerName: 'Existing Zendesk Ticket', width: 200 },
    { field: 'existing_zendesk_ticket_status', headerName: 'Existing Ticket Status', width: 250 },
    { field: 'created_zendesk_ticket_id', headerName: 'Created Zendesk Ticket', width: 200 },
    { field: 'created_zendesk_ticket_status', headerName: 'Created Ticket Status', width: 250 },
    { field: 'ticket_created', headerName: 'Created/Skipped', width: 150 },
    { field: 'reason', headerName: 'Reason(if any)', width: 150 },
  ],

//Use the below  for actual NMS logs api--Real column names to be used for NMSLOGS table
'Alert-Rules':[
  // { field: 'alert_timestamp',
  { field: 'start_time',
  headerName: 'Timestamp',
  width: 200,
  valueGetter: (params) => {
    const timestamp = params; // Ensure `params` has the correct timestamp value
    if (timestamp) {
      // Slice to remove seconds and milliseconds
      return timestamp.slice(0, 16);
    }
    return '-';
  },
 },
 { field: 'alert_id', headerName: 'Alert ID', width: 150 },
 { field: 'job_id', headerName: 'NMS Job ID', width: 300 },
 { field: 'brand_name', headerName: 'Brand Name', width: 150 },
 { field: 'estation_name', headerName: 'Store ID', width: 150 },
 { field: 'status', headerName: 'Status', width: 200 },
 { field: 'alert_message', headerName: 'Alert Message', width: 300 },
],

//////////////////////////////
//   users: [
//     { field: 'id', headerName: 'User ID', width: 150 },
//     { field: 'displayName', headerName: 'Display Name', width: 200 },
//     { field: 'company', headerName: 'Company', width: 150 },
//     { field: 'email', headerName: 'Email', width: 250 },
//     { field: 'userType', headerName: 'User Type', width: 100 },
//   ],

// admin: [
//     { field: 'displayName', headerName: 'User', width: 150 },
//     { field: 'company', headerName: 'Company', width: 150 },
//     { field: 'email', headerName: 'Email', width: 250 },
//     { field: 'userType', headerName: 'User Type', width: 100 },
//     { field: 'memberType', headerName: 'Member Type', width: 150 },
//     { field: 'organizations', headerName: 'Organizations', width: 150 },
//     { field: 'exceptions', headerName: 'Exceptions', width: 150 },
//   ],
};
